// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3lxtP","icon":"SortAdornment_icon__394Ry","up":"SortAdornment_up__2YI8W","down":"SortAdornment_down__2OpIv","active":"SortAdornment_active__21nIp"};